/**
 * Copyright © Veeam Software Group GmbH.
 */

import { CompanyStatusRepresentation } from '@veeam-vspc/models/web-controllers';

export type CompanyStatus = CompanyStatusRepresentation;
export const CompanyStatus = CompanyStatusRepresentation;

